import { Store } from 'redux';
import { isExtensionContext } from '@common-services/detect-context';
// import { AppThunkDispatch } from '@common/types/app-thunk-dispatch-type';
import { AppThunkDispatch, CommonRootState } from '@common/types/common-root-state-type';

// Singleton store instance
let storeInstance: Store | null = null;

// Function to get the store directly from the source
const getStoreDirectly = (): Store => {
    try {
        // Return cached store instance if it exists
        if (storeInstance) {
            return storeInstance;
        }
        
        // Create store instance only once
        if (isExtensionContext()) {
            // Import extension store
            storeInstance = require('@extension-context-common/store/extension-store').default;
            // console.log('[Notifier] Using extension store');
            // console.log(`[Notifier] isConnected: ${storeInstance.getState().NotifierReducer.isConnected}`);
        } else {
            // Import website store
            storeInstance = require('@website/store/web-store').default;
            // console.log('[Notifier] Using website store');
            // console.log(`[Notifier] isConnected: ${storeInstance.getState().NotifierReducer.isConnected}`);
        }
        if (!storeInstance) {
            throw new Error('Store instance was not initialized');
        }
        return storeInstance;
    } catch (error) {
        console.error('[Notifier] Failed to get store:', error);
        throw new Error('Failed to get Redux store');
    }
};

// Export the store instance - always get it directly
export const getStore = (): Store => {
    return getStoreDirectly();
};

// Safe dispatch function that handles errors
export const safeDispatch: AppThunkDispatch = (action: any) => {
    try {
        const store = getStoreDirectly();
        return store.dispatch(action);
    } catch (error) {
        console.error('[Notifier] Error dispatching action:', error);
        // Return the action without dispatching in case of error
        return action;
    }
};

// Export the original dispatch for backward compatibility
export const dispatch: AppThunkDispatch = (action: any) => {
    try {
        const store = getStoreDirectly();
        return store.dispatch(action);
    } catch (error) {
        console.error('[Notifier] Error in dispatch:', error);
        return action;
    }
};

// Export getState function with proper typing and error handling
export const getStateDirectly = (): CommonRootState => {
    try {
        const store = getStoreDirectly();
        return store.getState();
    } catch (error) {
        console.error('[Notifier] Error getting state:', error);
        // Return an empty state object as fallback
        return {} as CommonRootState;
    }
}; 